import React, { useState } from "react";
import CategorySelect from "./CategorySelect";
import "./InventoryTable.css";

const STATUS_OPTIONS = [
  { value: "enough", label: "🟢 Enough" },
  { value: "running_low", label: "🟡 Running Low" },
  { value: "finished", label: "🔴 Finished" },
];

const STATUS_CLASS = {
  enough: "status-enough",
  running_low: "status-low",
  finished: "status-finished",
};

export default function InventoryTable({ items, onStatusChange, onUpdate, onDelete }) {
  const [modal, setModal] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [editingId, setEditingId] = useState(null);
  const [editName, setEditName] = useState("");
  const [editCategory, setEditCategory] = useState("");

  const handleStatusChange = (item, newStatus) => {
    if (newStatus === "enough") { onStatusChange(item.id, newStatus, 0); return; }
    setQuantity(1);
    setModal({ itemId: item.id, itemName: item.name, status: newStatus });
  };

  const handleModalConfirm = () => {
    onStatusChange(modal.itemId, modal.status, quantity);
    setModal(null);
  };

  const handleStartEdit = (item) => {
    setEditingId(item.id);
    setEditName(item.name);
    setEditCategory(item.category || "");
  };

  const handleSaveEdit = async (item) => {
    if (!editName.trim()) return;
    await onUpdate(item.id, { name: editName.trim(), category: editCategory || null });
    setEditingId(null);
  };

  const handleCancelEdit = () => setEditingId(null);

  if (items.length === 0) {
    return (
      <div className="empty-state">
        <div className="empty-icon">📦</div>
        <p>No items found.</p>
      </div>
    );
  }

  return (
    <>
      {modal && (
        <div className="modal-overlay">
          <div className="modal">
            <h3 className="modal-title">How many do you need?</h3>
            <p className="modal-sub">{modal.itemName}</p>
            <input
              type="number" min="1" max="99"
              value={quantity}
              onChange={(e) => setQuantity(parseInt(e.target.value) || 1)}
              className="modal-input"
              autoFocus
            />
            <div className="modal-actions">
              <button className="btn-ghost" onClick={() => setModal(null)}>Cancel</button>
              <button className="btn-primary" onClick={handleModalConfirm}>Add to Cart</button>
            </div>
          </div>
        </div>
      )}

      <div className="inventory-table-wrap">
        <table className="inventory-table">
          <thead>
            <tr>
              <th>Item</th>
              <th>Category</th>
              <th>Status</th>
              <th>Updated</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.id}>
                {editingId === item.id ? (
                  <>
                    <td>
                      <input
                        className="edit-input"
                        value={editName}
                        onChange={(e) => setEditName(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") handleSaveEdit(item);
                          if (e.key === "Escape") handleCancelEdit();
                        }}
                        autoFocus
                      />
                    </td>
                    <td>
                      <CategorySelect
                        value={editCategory}
                        onChange={setEditCategory}
                      />
                    </td>
                    <td>
                      <select
                        className={`status-select ${STATUS_CLASS[item.status] || ""}`}
                        value={item.status}
                        onChange={(e) => handleStatusChange(item, e.target.value)}
                      >
                        {STATUS_OPTIONS.map((o) => (
                          <option key={o.value} value={o.value}>{o.label}</option>
                        ))}
                      </select>
                    </td>
                    <td className="item-date">
                      {new Date(item.updated_at).toLocaleDateString("en-US", { month: "short", day: "numeric" })}
                    </td>
                    <td>
                      <div className="edit-actions">
                        <button className="btn-save-edit" onClick={() => handleSaveEdit(item)}>✓</button>
                        <button className="btn-cancel-edit" onClick={handleCancelEdit}>✕</button>
                      </div>
                    </td>
                  </>
                ) : (
                  <>
                    <td className="item-name">{item.name}</td>
                    <td className="item-cat">{item.category || <span className="none">—</span>}</td>
                    <td>
                      <select
                        className={`status-select ${STATUS_CLASS[item.status] || ""}`}
                        value={item.status}
                        onChange={(e) => handleStatusChange(item, e.target.value)}
                      >
                        {STATUS_OPTIONS.map((o) => (
                          <option key={o.value} value={o.value}>{o.label}</option>
                        ))}
                      </select>
                    </td>
                    <td className="item-date">
                      {new Date(item.updated_at).toLocaleDateString("en-US", { month: "short", day: "numeric" })}
                    </td>
                    <td>
                      <div className="row-actions">
                        <button className="btn-edit" onClick={() => handleStartEdit(item)}>✏️</button>
                        <button className="btn-delete" onClick={() => onDelete(item.id)}>🗑</button>
                      </div>
                    </td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
